<i18n>
{
  "en": {
    "dontHaveAccount": "Don't have an account?",
    "email": "Email",
    "login": "Log In",
    "loginError": "Incorrect login or password!",
    "password": "Password",
    "signup": "Sign up"
  },
  "fr": {
    "dontHaveAccount": "Pas de compte ?",
    "email": "Courriel",
    "login": "Connexion au compte",
    "loginError": "Incorrect login or password!",
    "password": "Mot de passe",
    "signup": "Créer un compte"
  }
}
</i18n>
<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm4 mt-3>
        <v-card>
          <v-card-title primary-title>
            <div class="headline">
              {{ $t('login')}}
            </div>
          </v-card-title>
          <v-card-text>
            <form @submit.prevent="login">
              <messages-list :messages="messages"/>
              <v-layout column>
                <v-flex>
                  <v-text-field
                    name="email"
                    :label="$t('email')"
                    id="email"
                    type="email"
                    v-model.trim="email"
                    @input="$v.email.$touch()"
                    :rules="emailRules"/>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="password"
                    :label="$t('password')"
                    id="password"
                    type="password"
                    v-model.trim="password"
                    @input="$v.password.$touch()"
                    :rules="passwordRules"/>
                </v-flex>
                <v-flex align-self-center mt-5>
                  <v-btn color="primary" type="submit" :disabled="disableLoginBtn" :loading="loading">{{ $t('login') }}</v-btn>
                </v-flex>
              </v-layout>
            </form>
            <v-flex class="mt-3">
              {{ $t('dontHaveAccount') }} <router-link to="/signup">{{ $t('signup') }}</router-link>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import messagesList from '@/components/messages-list'

export default {
  name: 'login',
  components: {
    messagesList
  },
  data () {
    return {
      email: '',
      loading: false,
      messages: [],
      password: ''
    }
  },
  methods: {
    async login () {
      try {
        this.loading = true
        await this.$store.dispatch('loginUser', {
          username: this.email,
          password: this.password
        })
        this.loading = false
        this.$router.push('/')
      } catch (err) {
        this.messages = [this.$t('loginError')]
        this.loading = false
      }
    }
  },
  computed: {
    disableLoginBtn () {
      return this.$v.$invalid
    },
    emailRules () {
      return [() => this.$v.email.email || this.$t('validation.email'),
        () => (!this.$v.email.$dirty || this.$v.email.required) || this.$t('validation.required')]
    },
    passwordRules () {
      return [() => (!this.$v.password.$dirty || this.$v.password.required) || this.$t('validation.required')]
    }
  },
  validations: {
    email: {
      required, email
    },
    password: {
      required
    }
  }
}
</script>
